import React from 'react';
import { ReviewTemplateProps } from '../types';
import StarRating from '../../components/StarRating';
import { formatRecommendationDisplay, getRatingNumber } from '../../utils/formatters';
import { lightenColor } from '../../utils/colorUtils';
import SourceLogo from '../components/SourceLogo';

const ShareReviewTemplate2: React.FC<ReviewTemplateProps> = ({
    reviewerName,
    reviewText,
    rating,
    network,
    color = '#ef4444',
    logo,
    showLogo,
    showSource,
}) => {
    const numericRating = getRatingNumber(rating);
    const isFacebookRecommendation =
        network === 'facebook' && (rating === 'positive' || rating === 'negative');

    const lightColor = lightenColor(color, 60);

    return (
        <div
            className="w-[1080px] h-[1080px] px-24 pt-24 pb-11 relative rounded-[20px] inline-flex flex-col justify-start items-center gap-10 overflow-hidden"
            style={{ backgroundColor: lightColor }}
        >
            <div className="w-full h-80 bottom-0 absolute" style={{ backgroundColor: color }} />
            <div className="absolute z-[1000] top-[44px] left-[443px] w-[193px]">
                <svg
                    width="194"
                    height="160"
                    viewBox="0 0 194 160"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M133.71 81.0323C118.742 74.8387 109.452 61.4193 109.452 42.3225C109.452 17.0322 127.516 -5.73042e-06 150.742 -3.69996e-06C175.516 -1.53413e-06 193.064 17.5484 193.064 42.3226C193.064 54.1935 191 62.9677 181.71 86.7097L154.355 160L113.064 160L133.71 81.0323ZM24.2903 81.0322C9.32252 74.8387 0.0321894 61.4193 0.0321911 42.3225C0.0321933 17.0322 18.0967 -1.52962e-05 41.3225 -1.32657e-05C66.0967 -1.10999e-05 83.6451 17.5484 83.6451 42.3225C83.6451 54.1935 81.5806 62.9677 72.2903 86.7097L44.9354 160L3.64511 160L24.2903 81.0322Z"
                        fill={color}
                    />
                </svg>
            </div>

            <div className="w-[808px] h-[764px] px-10 pb-10 bg-white rounded-[40px] shadow-[0px_20px_10px_0px_rgba(0,0,0,0.25)] flex flex-col justify-between items-start relative">
                <div className="self-stretch flex flex-col justify-start items-start gap-12">
                    <div className="flex flex-col justify-center items-start gap-1 pt-40">
                        {!isFacebookRecommendation && (
                            <StarRating rating={numericRating} iconSize={'h-[67px]'} />
                        )}
                    </div>
                    <div
                        className={`self-stretch text-left text-black ${isFacebookRecommendation && 'pt-40'} text-5xl font-semibold font-['Montserrat'] leading-[50.40px]`}
                    >
                        {reviewText}
                    </div>
                </div>

                <div
                    className={`self-stretch inline-flex items-center ${isFacebookRecommendation ? 'justify-between' : 'justify-start'}`}
                >
                    <div className="text-black text-[40px] font-semibold font-['Montserrat'] leading-[42px]">
                        {reviewerName}
                    </div>

                    {isFacebookRecommendation && (
                        <div>{formatRecommendationDisplay(rating, 'template2')}</div>
                    )}
                </div>
            </div>

            <div
                className={`h-[96px] w-full absolute bottom-[44px] left-0 right-0 px-24 flex items-center ${showLogo && logo && showSource ? 'justify-between' : 'justify-center'}`}
                style={{ zIndex: 1000 }}
            >
                {showLogo && logo && (
                    <img
                        src={logo}
                        alt="Logo"
                        className="w-auto h-full object-contain"
                        crossOrigin="anonymous"
                    />
                )}
                {showSource && <SourceLogo network={network} template="template2" />}
            </div>
        </div>
    );
};

export default ShareReviewTemplate2;
